var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import Icon from '..';
import IconLink from '../IconLink';
import { ReactComponent as LinkedIn } from '../../../images/Svgs/linkedIn.svg';
import { ReactComponent as Twitter } from '../../../images/Svgs/icon_twitter.svg';
import { ReactComponent as Facebook } from '../../../images/Svgs/icon_facebook.svg';
import { ReactComponent as Dots } from '../../../images/Svgs/dots.svg';
import './index.scss';
var Dropdown = function () {
    var _a = useState(false), isActive = _a[0], setIsActive = _a[1];
    var dropDownRef = useRef(null);
    var onClick = function () { return setIsActive(!isActive); };
    return (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: _jsx(Dots, {}, void 0), onClick: onClick }, void 0),
            isActive ? (_jsxs("ul", __assign({ id: "social-dropwdown", className: "social__social-dropdown" }, { children: [_jsx("li", { children: "Copy link" }, void 0),
                    _jsx("li", { children: "Email" }, void 0),
                    _jsx("li", { children: "Download" }, void 0),
                    _jsx("li", { children: "Print" }, void 0)] }), void 0)) : null] }, void 0));
};
var SocialIcons = function (_a) {
    var socials = _a.socials, moreOptions = _a.moreOptions;
    return (_jsxs("div", __assign({ className: "SocialIcons" }, { children: [_jsxs("div", __assign({ className: "SocialContainer" }, { children: [_jsx(IconLink, { iconLink: socials === null || socials === void 0 ? void 0 : socials.linkedin, icon: _jsx(LinkedIn, {}, void 0) }, void 0),
                    _jsx(IconLink, { iconLink: socials === null || socials === void 0 ? void 0 : socials.twitter, icon: _jsx(Twitter, {}, void 0) }, void 0),
                    _jsx(IconLink, { iconLink: socials === null || socials === void 0 ? void 0 : socials.facebook, icon: _jsx(Facebook, {}, void 0) }, void 0)] }), void 0),
            _jsx(Dropdown, {}, void 0)] }), void 0));
};
export default SocialIcons;
